export default __webpack_public_path__ + "static/media/Snd_F_Starts.ba726544.mp3";